<template>
  <div class="froala">
    <froala :tag="'textarea'" :config="config" v-model="model"></froala>
  </div>
</template>

<script>
import VueFroala from "vue-froala-wysiwyg";

export default {
  name: "app",
  props: {
    value: {
      type: String,
      default: "",
    },
    buttons: {
      type: Array,
      default: () => [
        "paragraphFormat",
        "fontFamily",
        "fontSize",
        "textColor",
        "bold",
        "italic",
        "underline",
        "clearFormatting",
        "strikeThrough",
        "color",
        "backgroundColor",
        // "inlineStyle",
        "align",
        "formatOL",
        "formatUL",
        "outdent",
        "indent",
        // "quote",
        // 'insertLink',
        "insertImage",
        // 'insertVideo',
        // 'embedly',
        // 'insertFile',
        // "insertTable",
        // 'emoticons',
        "specialCharacters",
        "insertHR",
        "selectAll",
        "print",
        "spellChecker",
        "html",
        "help",
        "clear",
        // "save",
        "undo",
        "redo",
        "fullscreen",
      ],
    },
  },
  watch: {
    model(vaule) {
      this.$emit("input", vaule);
    },
    value: {
      handler(vaule) {
        this.model = vaule;
      },
      immediate: true,
    },
  },
  data() {
    const that = this;
    return {
      config: {
        toolbarButtons: this.buttons,
        language: "zh_cn", // 国际化
        imageUploadParam: "img",
        imageUploadURL: this.$http.defaults.baseURL + "/upload",
        imageUploadMethod: "POST",
        imageDefaultAlign: "left",
        imageUploadParams: { isFroala: true },
        imageMaxSize: 1 * 1024 * 1024,
        imageDefaultWidth: 0, //上传图片后的默认大小
        events: {
          "froalaEditor.initialized": function () {
            console.log("initialized");
          },
          "image.beforePasteUpload": function (img) {
            let src = img.dataset.src;
            if (src.includes("https://mmbiz.qpic.cn")) {
              img.src = src;
              return false;
            }
            return true;
          },
          'image.error': function (error, response) {
            if(error.message === 'File is too large.') {
             return that.$message.error('图片大小不能超过1M');
            }
            return this.$message.error(error.message);
           },
        },
      },
      model: "",
    };
  },
  mounted() {},
};
</script>
